import { createContext } from "react";

interface ModalContextProps {
  onClose?: () => void;
  open: boolean;
  setOpen?: (open: boolean) => void;
}
export const ModalContext = createContext<ModalContextProps>({
  onClose: undefined,
  open: false,
  setOpen: undefined,
});

interface ModalContextProviderProps {
  children: React.ReactNode;
  context: ModalContextProps;
}
export function ModalContextProvider({
  children,
  context,
}: ModalContextProviderProps) {
  return (
    <ModalContext.Provider value={context}>{children}</ModalContext.Provider>
  );
}
